<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">Amy Taylor Cook has been an aspiring author since she could hold a pen. Her debut novel <em>Sometime in August</em> is based partly on her own experiences with mental health, and it aims to discuss the topic in a blunt and relatable manner.</p>
<p style="text-indent:00em; padding-top:15px;">Amy grew up in East Kilbride, Greater Glasgow, where she currently lives with her fiancé along with pet snails and a huge collection of books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5de4891f